/**
 * If a contentId is provided in a resource object, use it to determine the returned text from phraseapp.
 * If contentId is not provided use the specified property of the resource object.
 * The component prop is used in conjunction with `getMessage` to retrieve the `formatMessage` reference.
 */
import getMessage from "@irati/utils/lang/helpers/getMessage"

import {replacePlaceholders} from "./index"


const util = {}

util.getContentIdOrDefault = (component, resource, property) => {
  const {contentId} = resource
  return contentId ? getMessage(component, `${contentId}.${property}`) : resource[property]
}

util.formatQuestionText = (component, question, placeholders) => {
  const questionText = util.getContentIdOrDefault(component, question, "text")
  return replacePlaceholders(questionText, placeholders)
}

util.formatDriverName = (component, driver) => {
  return util.getContentIdOrDefault(component, driver, "name")
}

util.formatDriverDescription = (component, driver) => {
  return util.getContentIdOrDefault(component, driver, "description")
}

util.formatAnswerText = (component, answer) => {
  return util.getContentIdOrDefault(component, answer, "text")
}

export default util
